import { jsxs, jsx } from 'react/jsx-runtime';
import { styled } from 'styled-components';
import { useAuthStatus, useRouter, Link } from '@fabric-app/compat';
import { Button } from '@fabric-app/ui/components/Button';
import { setRedirectUrlAfterAuth } from '@fabric-app/compat/capabilities/auth';

const Container = styled.div.withConfig({
  displayName: "AnonBottomBarSignup__Container",
  componentId: "sc-cd856f16-0"
})([
  `padding:1rem;text-align:center;display:flex;flex-direction:column;gap:0.75rem;color:white;font-size:0.875rem;border-top:1px solid rgba(255,255,255,0.1);`
]);
const AnonBottomBarSignup = ({ children }) => {
  const authStatus = useAuthStatus();
  const router = useRouter();
  return /* @__PURE__ */ jsxs(Container, {
    children: [
      children,
      authStatus !== "authenticated" && /* @__PURE__ */ jsx(Button, {
        variant: "primary-inverse",
        as: Link,
        style: {
          width: "100%"
        },
        href: `/beta-sign-up-exclusive-link/from-shared`,
        onClick: () => {
          setRedirectUrlAfterAuth(router.asPath);
        },
        children: "Sign up / Login"
      })
    ]
  });
};

export { AnonBottomBarSignup };
//# sourceMappingURL=AnonBottomBarSignup.js.map
